// Product display names and groupings
export interface ProductOption {
  label: string
  value: string
  category: string
}

export const productOptions: ProductOption[] = [
  // Core Solutions
  {
    label: 'GC Online Giving (incl Social Fundraising and Giving Forms)',
    value: 'Online Giving',
    category: 'Core Solutions',
  },
  { label: 'GC Events', value: 'Events', category: 'Core Solutions' },
  { label: 'GC Gift Officer', value: 'GO', category: 'Core Solutions' },
  {
    label: 'GC Volunteer Management: Reimagined',
    value: 'VM Reimagined',
    category: 'Core Solutions',
  },

  // Platform Apps
  { label: 'GC Outreach', value: 'Outreach', category: 'Platform Apps' },
  { label: 'Wealth Data (add-on)', value: 'Wealth', category: 'Platform Apps' },
]

export function getProductOptions(): ProductOption[] {
  return productOptions
}

export function getProductValue(label: string): string | undefined {
  return productOptions.find((opt) => opt.label === label)?.value
}

export function getProductLabel(value: string): string | undefined {
  return productOptions.find((opt) => opt.value === value)?.label
}
